module.exports = __webpack_public_path__ + "img/Icon_Snapchat.c897c261.svg";